<template>
  <el-popover trigger="manual" popper-class="address-selector-popover" width="340" v-model="visible"
              :placement="placement" @show="initValue()"
  >
    <div v-clickoutside="onClickoutside" @mousedown.prevent>
      <ul @click.stop class="header">
        <li :class="{selected: province, active: currentStep === 1}" @click="switchView(1)">
          <span>{{ province && province.name || '省' }}<i class="zpc-iconjiantou"></i></span>
        </li>
        <li :class="{selected: city, active: currentStep === 2}" v-if="level > 1" @click="switchView(2)">
          <span>{{ city && city.name || '市' }}<i class="zpc-iconjiantou"></i></span>
        </li>
        <li :class="{selected: area, active: currentStep === 3}" v-if="level > 2" @click="switchView(3)">
          <span>{{ area && area.name || '区/县' }}<i class="zpc-iconjiantou"></i></span>
        </li>
      </ul>
      <div class="address-list" @click.stop :class="{'has-all': showAll}">
        <div class="province-view" v-if="currentStep === 1">
          <a href="javascript:" @click="selectAll(1)" class="link">全部省份</a>
          <div v-for="(item, idx) in provinceGroups" :key="idx">
            <div class="label">{{ item.start }}-{{ item.end }}</div>
            <div class="list">
              <div @click="selectItem(1, prov)" class="link" :class="{selected: prov === province}"
                   v-for="prov in item.list" :key="prov.name"
              >
                {{ prov.name }}
              </div>
            </div>
          </div>
        </div>
        <div class="city-view" v-if="currentStep === 2 && province">
          <a href="javascript:" @click="selectAll(2)" class="link">全部城市</a>
          <div @click="selectItem(2, item)" class="link" :class="{selected: city === item}"
               v-for="item in province.children" :key="item.name"
          >
            {{ item.name }}
          </div>
        </div>
        <div class="area-view" v-if="currentStep === 3 && city">
          <a href="javascript:" @click="selectAll(3)" class="link">全部区县</a>
          <div @click="selectItem(3, item)" class="link" :class="{selected: area === item}"
               v-for="item in city.children" :key="item.name"
          >
            {{ item.name }}
          </div>
        </div>
      </div>
    </div>
    <div class="address-selector" slot="reference" @click="toggle" tabindex="0">
      <span :class="{placeholder: grayPlaceholder && isPlaceholder}">{{ text }}</span>
      <i class="el-icon-circle-close" v-if="clearable && valueText" @click.stop="clear(true)"></i>
      <i class="el-icon-arrow-up" :class="{'is-reverse': !visible}"></i>
    </div>
  </el-popover>
</template>

<script>
import _ from 'lodash'
import Clickoutside from 'element-ui/src/utils/clickoutside'
// event @input @change
export default {
  directives: { Clickoutside },
  props: {
    value: {
      type: Array,
      default () {
        return []
      }
    },
    placeholder: {
      type: String,
      default () {
        return '请选择地址'
      }
    },
    placement: {
      type: String,
      default () {
        return 'bottom-start'
      }
    },
    // 如果传入 sourceObject, 则选择的变更会直接设置到此对象中的 province/city/area
    sourceObject: {
      type: Object,
      default () {
        return false
      }
    },
    // 级别,默认是3级,最低可以设置成1级
    level: {
      type: Number,
      default () {
        return 3
      }
    },
    clearable: {
      type: Boolean,
      default () {
        return true
      }
    },
    // 是否展示[全部省份][全部城市]或[全部区县]按钮
    showAll: {
      type: Boolean,
      default () {
        return false
      }
    },
    // 可选的最小级别
    leafLevel: {
      type: Number,
      default () {
        return 3
      }
    },
    // 是否显示灰色的默认文本
    grayPlaceholder: {
      type: Boolean,
      default () {
        return true
      }
    },
    // 是否在关闭后才抛出change事件
    changeOnClose: {
      type: Boolean,
      default () {
        return true
      }
    }
  },
  data () {
    return {
      loading: false,
      visible: false,
      province: null,
      city: null,
      area: null,
      currentStep: 1
    }
  },
  mounted () {
    if (!this.regions || !this.regions.length) {
      this.loading = true
      this.$store.dispatch('loadAreas').then(() => {
        this.loading = false
      })
    }
  },
  methods: {
    onClickoutside () {
      if (this.visible) {
        this.closeTimeoutHandler = setTimeout(() => {
          this.visible = false
        }, 100)
      }
    },
    selectItem (idx, item) {
      if (idx === 1) {
        if (item !== this.province) {
          this.province = item
          this.city = null
          this.area = null
          this.currentStep = 2
          if (this.leafLevel < 2) {
            this.setValue()
          }
        }
      } else if (idx === 2) {
        if (item !== this.city) {
          this.city = item
          this.area = null
          if (this.level <= 2) {
            this.setValue()
            this.toggle()
          } else {
            this.currentStep = 3
            if (this.leafLevel < 3) {
              this.setValue()
            }
          }
        }
      } else if (idx === 3) {
        if (item !== this.area) {
          this.area = item
          this.setValue()
          this.toggle()
        }
      }
    },
    selectAll (idx) {
      switch (idx) {
        case 1:
          this.clear(true)
          break
        case 2:
          this.city = null
          this.area = null
          if (this.leafLevel < 2) {
            this.setValue()
          }
          break
        case 3:
          this.area = null
          if (this.leafLevel < 3) {
            this.setValue()
          }
          break
      }
      this.visible = false
    },
    switchView (idx) {
      this.currentStep = (idx === 2 && this.province) || (idx === 3 && this.city) ? idx : 1
    },
    toggle () {
      this.visible = !this.visible
    },
    handleClearClick () {
      this.$emit('input', [])
    },
    clear (triggerChangeEvent) {
      this.province = null
      this.city = null
      this.area = null
      this.setValue()
      this.visible = false
      triggerChangeEvent && this.$emit('change', [this.province, this.city, this.area])
    },
    setValue () {
      if (this.sourceObject) {
        this.$set(this.sourceObject, 'province', (this.province && this.province.name) || '')
        this.$set(this.sourceObject, 'city', this.level > 1 ? (this.city && this.city.name) || '' : undefined)
        this.$set(this.sourceObject, 'area', this.level > 2 ? (this.area && this.area.name) || '' : undefined)
      } else {
        this.$emit('input', this.currentValue)
      }
      this.changed = true
      if (!this.changeOnClose) {
        this.$emit('change', [this.province, this.city, this.area])
      }
    },
    // 初始化传入的数据
    initValue () {
      this.currentStep = 1
      let provinceValue
      let cityValue
      let areaValue
      if (this.sourceObject || this.value) {
        if (this.sourceObject) {
          provinceValue = this.sourceObject.province
          cityValue = this.sourceObject.city
          areaValue = this.sourceObject.area
        } else if (this.value) {
          provinceValue = this.value[0]
          cityValue = this.value[1]
          areaValue = this.value[2]
        }
        if (this.regions && this.regions.length) {
          if (provinceValue) {
            let isString = _.isString(provinceValue)
            this.province = _.find(this.regions, e => isString ? e.name === provinceValue : e === provinceValue)
            if (this.province && cityValue) {
              let isString = _.isString(cityValue)
              this.city = _.find(this.province.children, e => isString ? e.name === cityValue : e === cityValue)
              if (this.city && areaValue) {
                let isString = _.isString(areaValue)
                this.area = _.find(this.city.children, e => isString ? e.name === areaValue : e === areaValue)
              } else {
                this.area = null
              }
            } else {
              this.city = null
              this.area = null
            }
          } else {
            this.province = null
            this.city = null
            this.area = null
          }
        }
      } else {
        this.province = null
        this.city = null
        this.area = null
      }
      if (!_.isEqual(this.value, this.currentValue)) {
        this.setValue()
      }
      this.changed = false
    }
  },
  computed: {
    regions () {
      return this.$store.state.areas || []
    },
    currentValue () {
      let arr = [this.province]
      this.level > 1 && arr.push(this.city)
      this.level > 2 && arr.push(this.area)
      return arr
    },
    valueText () {
      let str
      if (this.sourceObject) {
        str = `${this.sourceObject.province || ''}${this.sourceObject.city ? '/' + this.sourceObject.city : ''}${this.sourceObject.area ? '/' + this.sourceObject.area : ''}`
      } else {
        str = this.value ? `${this.value[0] || ''}${this.value[1] ? '/' + this.value[1] : ''}${this.value[2] ? '/' + this.value[2] : ''}` : ''
      }
      return str
    },
    text () {
      return this.loading ? '加载中...' : this.valueText || this.placeholder
    },
    isPlaceholder () {
      return !this.valueText
    },
    provinceGroups () {
      let groups = [
        {
          start: 'A',
          end: 'G',
          list: []
        },
        {
          start: 'H',
          end: 'K',
          list: []
        },
        {
          start: 'L',
          end: 'Z',
          list: []
        }
      ]
      for (let province of this.regions) {
        for (let group of groups) {
          if (province.py[0] >= group.start && province.py[0] <= group.end) {
            group.list.push(province)
            break
          }
        }
      }
      return groups
    }
  },
  watch: {
    value () {
      this.initValue()
    },
    visible (val) {
      if (!val && this.changeOnClose) {
        this.changed && this.$emit('change', [this.province, this.city, this.area])
        this.changed = false
      }
      if (!val && this.closeTimeoutHandler) {
        clearTimeout(this.closeTimeoutHandler)
        this.closeTimeoutHandler = 0
      }
    }
  }
}
</script>
